/**
 * Normalized Create React App env. Access via this module for consistency.
 * REACT_APP_* is inlined at compile time — restart `npm start` after changing .env.
 */

/** Strips BOM/CR and trailing slashes from URL env vars (Windows .env often uses CRLF). */
function normalizeEnvUrl(value) {
    if (value == null || value === '') return '';
    return String(value)
        .replace(/^\uFEFF/, '')
        .trim()
        .replace(/\r$/, '')
        .replace(/\/+$/, '');
}

/** Deployed LMS FastAPI (POST /api/lms/validate_and_store). Used when REACT_APP_BACKEND_BASE_URL is unset. */
const DEFAULT_BACKEND_BASE_URL = 'http://api.techstuffs.in';

const backendFromEnv = normalizeEnvUrl(process.env.REACT_APP_BACKEND_BASE_URL);

/** Windows .env often uses CRLF; strip \r so comma-split lists stay valid. */
const adminEmailsRaw = String(process.env.REACT_APP_ADMIN_EMAILS || '')
    .replace(/^\uFEFF/, '')
    .replace(/\r/g, '')
    .trim();

export const env = {
    supabaseUrl: process.env.REACT_APP_SUPABASE_URL,
    supabaseAnonKey: process.env.REACT_APP_SUPABASE_ANON_KEY,
    backendBaseUrl: backendFromEnv || DEFAULT_BACKEND_BASE_URL,
    zoomClientId: process.env.REACT_APP_ZOOM_CLIENT_ID || '',
    zoomRedirectUri: process.env.REACT_APP_ZOOM_REDIRECT_URI || '',
    /** Comma-separated emails allowed to open /admin (must match Supabase RLS). */
    adminEmails: adminEmailsRaw
        .split(',')
        .map((s) => s.trim().toLowerCase())
        .filter(Boolean),
};
